export const API_BASE_URL = 'https://offer.app20.co';
export const BASE_URL = 'https://backend.app20.co';
export const WEBSITE_URL = 'https://app20.co';
export const FORMSPREE_URL = 'https://formspree.io/f/mojqqnjb';